import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "container-fluid" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "col-12 bg-light p-3" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "d-flex justify-content-between" }, [
    /*#__PURE__*/_createElementVNode("h2", null, "Daily Sales Report")
  ])
], -1)
const _hoisted_4 = { class: "col-4 mt-4" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("label", {
  for: "exampleFormControlInput1",
  class: "form-label"
}, "City", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("option", { value: "0" }, "All cities", -1)
const _hoisted_7 = ["value"]
const _hoisted_8 = { class: "col-4 mt-4" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("label", {
  for: "floatingInput",
  class: "txt-right"
}, "From Date", -1)
const _hoisted_10 = { class: "form-floating" }
const _hoisted_11 = { class: "col-md-3 mt-4 text-start" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", { id: "chartdaily" }, null, -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("br", null, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_datepicker = _resolveComponent("datepicker")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _withDirectives(_createElementVNode("select", {
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.formdata.city_id) = $event)),
            class: "form-control"
          }, [
            _hoisted_6,
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.cities, (city) => {
              return (_openBlock(), _createElementBlock("option", {
                key: city.id,
                value: city.id
              }, _toDisplayString(city.name), 9, _hoisted_7))
            }), 128))
          ], 512), [
            [_vModelSelect, $setup.formdata.city_id]
          ])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _hoisted_9,
          _createElementVNode("div", _hoisted_10, [
            _createVNode(_component_datepicker, {
              modelValue: $setup.formdata.fromdate,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.formdata.fromdate) = $event)),
              class: "form-control"
            }, null, 8, ["modelValue"])
          ])
        ]),
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("button", {
            class: "btn btn-large btn-primary",
            onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => ($setup.cityBasedCall && $setup.cityBasedCall(...args)))
          }, "Search")
        ])
      ])
    ]),
    _hoisted_12,
    _hoisted_13,
    _hoisted_14,
    _hoisted_15,
    _hoisted_16
  ], 64))
}